import { Fragment } from "react";

import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const SpanIconCheckSelect = () => {
  return (
    <Fragment>
      <span className="absolute inset-y-0 left-0 flex items-center pl-1.5 text-primary-500 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
        <FontAwesomeIcon
          icon={faCheck}
          className="h-5 w-5"
          aria-hidden="true"
        />
      </span>
    </Fragment>
  );
};
